import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <section className="policy-hero">
        <h1>Privacy Policy</h1>
        <p className="policy-tagline">Last updated: April 18, 2026</p>
      </section>

      <section className="policy-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to StoryBuddy ("we", "our", or "us"). We are committed to protecting the
          privacy of children and families who use our platform. This Privacy Policy explains
          how we collect, use, and safeguard your information when you visit storybuddy.org.
        </p>
      </section>

      <section className="policy-section">
        <h2>2. Information We Collect</h2>
        <p>
          When you sign in using Google or Facebook, we collect your name and email address
          from your social login provider. We also collect information you voluntarily provide,
          such as child profiles (first name, age, interests) used to personalize stories.
          We do not collect sensitive personal information or payment data.
        </p>
      </section>

      <section className="policy-section">
        <h2>3. How We Use Your Information</h2>
        <p>
          We use your information to create and display personalized AI-generated stories,
          save your story library and preferences, enable features like ratings and comments,
          and improve the StoryBuddy platform. We do not sell your personal information to
          third parties. We do not use your data for advertising purposes.
        </p>
      </section>

      <section className="policy-section">
        <h2>4. Children's Privacy</h2>
        <p>
          StoryBuddy is designed for use by parents and guardians on behalf of children.
          We do not knowingly collect personal information directly from children under 13.
          Child profile information (name, age, interests) is entered by the parent/guardian
          account holder and is used solely to personalize story content.
        </p>
      </section>

      <section className="policy-section">
        <h2>5. Third-Party Services</h2>
        <p>
          We use Firebase (Google) for authentication, MongoDB Atlas for data storage,
          Cloudinary for image hosting, and Leonardo AI for image generation. Each of these
          services has its own privacy policy. We use OpenAI's API for story text generation.
          When you sign in with Facebook, Facebook's data practices are governed by Meta's
          Privacy Policy.
        </p>
      </section>

      <section className="policy-section">
        <h2>6. Data Retention</h2>
        <p>
          We retain your account information and stories for as long as your account is active.
          You may request deletion of your account and associated data at any time by visiting
          our <a href="/data-deletion">Data Deletion page</a> or by emailing us at{" "}
          <a href="mailto:storybuddyorg@gmail.com">storybuddyorg@gmail.com</a>.
        </p>
      </section>

      <section className="policy-section">
        <h2>7. Cookies</h2>
        <p>
          We use browser localStorage to store your authentication token and preferences.
          We do not use third-party tracking cookies.
        </p>
      </section>

      <section className="policy-section">
        <h2>8. Your Rights</h2>
        <p>
          You have the right to access, correct, or delete your personal data at any time.
          To exercise these rights, visit our <a href="/data-deletion">Data Deletion page</a>{" "}
          or contact us at{" "}
          <a href="mailto:storybuddyorg@gmail.com">storybuddyorg@gmail.com</a>.
        </p>
      </section>

      <section className="policy-section">
        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify users of
          significant changes by posting the updated policy on this page with a new date.
          Continued use of StoryBuddy after changes constitutes acceptance of the updated policy.
        </p>
      </section>

      <section className="policy-section">
        <h2>10. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:{" "}
          <a href="mailto:storybuddyorg@gmail.com">storybuddyorg@gmail.com</a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
